import { colors, fontSize, fontWeight, radius, space } from "../../lib/tokens";

interface Props {
  label: string;
  value: string;
  placeholder?: string;
  onChange: (next: string) => void;
  error?: string | null;
}

export function TextField({ label, value, placeholder, onChange, error }: Props) {
  return (
    <label style={{ display: "block", marginBottom: space.md }}>
      <span style={{ display: "block", fontSize: fontSize.sm, fontWeight: fontWeight.medium, color: colors.stone, marginBottom: 6 }}>
        {label}
      </span>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%", height: 36, padding: "0 12px",
          background: colors.white, border: `1px solid ${error ? colors.error : colors.fog}`,
          borderRadius: radius.sm, fontSize: fontSize.md, color: colors.ink,
          fontFamily: "inherit", outline: "none",
        }}
      />
      {error && (
        <span style={{ display: "block", fontSize: fontSize.sm, color: colors.error, marginTop: 4 }}>{error}</span>
      )}
    </label>
  );
}
